import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReply } from "@fortawesome/free-solid-svg-icons";

interface IIcon {
  color: string;
}

const TraceBackIcon: React.FC<IIcon> = ({ color }) => {
  return <FontAwesomeIcon icon={faReply} style={{ color }} />;
};

export default TraceBackIcon;
